import { getFirestore } from 'firebase/firestore';
import { app } from './app';
import createDbController from '../factory/createDbController';
var firestore = getFirestore(app);
export var db = {
    tests: createDbController(firestore, 'tests'),
    analytics: createDbController(firestore, 'analytics'),
    patientInformation: createDbController(firestore, 'patient-information'),
};
